/**
 * 品牌池（商务代言批 2026-10-30）：文案唯一来源 = docs/品牌文案填写表.md（id/品牌名/档/品类已定稿，
 * tagline 走填写表维护后补导）。逻辑消费方 = EndorsementSystem（递约带/报价/排他），呈现消费方 = 丙工位
 * （经纪人 VN+签约弹窗·重档）。⛔ id 导码后不得改（rejected 记账、在约合约都按 id 引用）。
 * 档位语义（玩法设计.md §六）：ws 微商（虚高掉口碑）/ cl 潮流 / xf 新消费 / gm 国民（基准价）/ gs 高奢（全阶梯）。
 * tagline=内部风味档（2026-10-30 茄子令）：⛔ 不接显示——签约决策信息由品牌/品类/title/报酬/年限+经纪人点评承载，
 * 本字段只作世界观锚与同档多品牌区分的助记，UI 任何面板不得渲染。
 */
import { BrandDef } from '../types';

export const BRANDS: BrandDef[] = [
    // ===== 美妆护肤 =====
    { id: 'BRD-WS-01', name: '慕妍夫人', tier: 'ws', category: 'mei', tagline: '顶着贵妇膏招牌，话术比配方足' },
    { id: 'BRD-WS-02', name: '金黛颜', tier: 'ws', category: 'mei', tagline: '黄金瓶逆龄概念，越贵越信' },
    { id: 'BRD-WS-03', name: '御颜妃', tier: 'ws', category: 'mei', tagline: '宫廷御方包装，古法熬制噱头' },
    { id: 'BRD-XF-01', name: '兰芷子', tier: 'xf', category: 'mei', tagline: '国风彩妆，一支口红讲一个典故' },
    { id: 'BRD-GM-05', name: '洁佳净', tier: 'gm', category: 'mei', tagline: '国民日化，洗手台上一半是它' },
    { id: 'BRD-GS-03', name: '姈碧', tier: 'gs', category: 'mei', tagline: '高定护肤线，柜台比实验室难进' },
    { id: 'BRD-GS-06', name: '海清之神', tier: 'gs', category: 'mei', tagline: '深海巨藻慢酵，修复面霜的传奇' },
    // ===== 服饰 =====
    { id: 'BRD-WS-08', name: '名媛汇', tier: 'ws', category: 'chuan', tagline: '名媛风女装，主打穿出去有面子' },
    { id: 'BRD-CL-01', name: 'ROWD8', tier: 'cl', category: 'chuan', tagline: '街头宽松版型，只认敢穿的人' },
    { id: 'BRD-CL-02', name: 'BLKLAB', tier: 'cl', category: 'chuan', tagline: '黑白极简实验室，联名比主线贵' },
    { id: 'BRD-GS-04', name: '索澜', tier: 'gs', category: 'chuan', tagline: '高定成衣，秀场一年只走一场' },
    // ===== 食品饮料 =====
    { id: 'BRD-WS-04', name: '御臻燕', tier: 'ws', category: 'shi', tagline: '即食燕窝礼盒，主打滋补面子和排场' },
    { id: 'BRD-WS-05', name: '初慕胶原', tier: 'ws', category: 'shi', tagline: '胶原小瓶饮，功效词堆到满' },
    { id: 'BRD-WS-09', name: '纤姿代餐', tier: 'ws', category: 'shi', tagline: '代餐奶昔，体重承诺张口就来' },
    { id: 'BRD-CL-03', name: '开盖犇', tier: 'cl', category: 'shi', tagline: '能量饮，电竞音乐节常客，包装比配方吵' },
    { id: 'BRD-XF-03', name: '轻汽', tier: 'xf', category: 'shi', tagline: '零糖气泡水，主打一个轻盈' },
    { id: 'BRD-XF-04', name: '拾茶记', tier: 'xf', category: 'shi', tagline: '国风新茶饮，排队比味道出名' },
    { id: 'BRD-GM-01', name: '丰禾乳业', tier: 'gm', category: 'shi', tagline: '国民乳企，广告语三代人都会背' },
    { id: 'BRD-GM-02', name: '云岭山泉', tier: 'gm', category: 'shi', tagline: '全国铺货的山泉，货架第一排' },
    // ===== 3C数码 =====
    { id: 'BRD-WS-07', name: '妆颜工坊', tier: 'ws', category: 'shu', tagline: '贴牌美容仪，参数写得比功效还玄' },
    { id: 'BRD-CL-04', name: 'BASSIC', tier: 'cl', category: 'shu', tagline: '低音轰头的耳机，主打现场感' },
    { id: 'BRD-XF-05', name: '岚声', tier: 'xf', category: 'shu', tagline: '做声学的，参数摆桌上谈' },
    // ===== 汽车 =====
    { id: 'BRD-GM-04', name: '领航汽车', tier: 'gm', category: 'che', tagline: '国产汽车头部，主打家庭第一辆车' },
    { id: 'BRD-GS-05', name: '朗瑟', tier: 'gs', category: 'che', tagline: '高定汽车，一辆车等一年' },
    // ===== 游戏互联网 =====
    { id: 'BRD-CL-05', name: 'GGX', tier: 'cl', category: 'you', tagline: '电竞潮玩厂牌，赛事梗比广告多' },
    { id: 'BRD-XF-06', name: '山海司', tier: 'xf', category: 'you', tagline: '国风自研厂牌，世界观比广告长' },
    // ===== 珠宝高奢 =====
    { id: 'BRD-GS-01', name: '斐珞', tier: 'gs', category: 'bao', tagline: '高级珠宝，橱窗一年只换两次' },
    { id: 'BRD-GS-02', name: '奥岚', tier: 'gs', category: 'bao', tagline: '法式珠宝，二十年只开九家店' },
    // ===== 母婴家居 =====
    { id: 'BRD-WS-06', name: '婴姿宝', tier: 'ws', category: 'jia', tagline: '婴童护肤贴牌，专家背书挂满页' },
    { id: 'BRD-XF-02', name: '棉朵家', tier: 'xf', category: 'jia', tagline: '婴童棉品家居，只讲安心不讲概念' },
    { id: 'BRD-GM-03', name: '万家家电', tier: 'gm', category: 'jia', tagline: '三十年家电老牌，家家都有一台' },
];

/** id → 品牌索引（运行时查表，同 SCRIPT_MAP 惯例） */
export const BRAND_MAP: Record<string, BrandDef> = Object.fromEntries(BRANDS.map(b => [b.id, b]));
